import React from 'react';
import PropTypes from 'prop-types';
import LinkButtonA from '../../../molecules/link-button/LinkButtonA';
import ActionBar from '../../../molecules/page-manage/action-bar';
import ThankYouDeleteModal from '../thank-you-delete-modal';

const ThankYouActionBar = function ThankYouActionBar(props) {
    const {
        page, baseurl, charityslug, legacyurl,
    } = props;

    const { protocol, host } = new URL(baseurl);

    return (
        <ActionBar>
            <LinkButtonA key={`edit-${page.Title}`} id={`edit-${page.Title}`} href={`${legacyurl}account/thankyoupage/${page.Path}?uuid=${page.UUID}`} target="_parent">
                <i className="fa fa-pencil" aria-hidden="true" style={{ fontSize: 'large' }} />
            </LinkButtonA>

            <LinkButtonA key={`preview-${page.Title}`} id={`preview-${page.Title}`} href={`${protocol}//${host}/features/thanks/${charityslug}/${page.Path}`} target="_parent">
                <i className="fa fa-eye" aria-hidden="true" style={{ fontSize: 'large' }} />
            </LinkButtonA>

            <ThankYouDeleteModal page={page} />
        </ActionBar>
    );
};

ThankYouActionBar.propTypes = {
    legacyurl: PropTypes.string,
    baseurl: PropTypes.string,
    charityslug: PropTypes.string.isRequired,
    page: PropTypes.shape({
        Key: PropTypes.string,
        Path: PropTypes.string,
        Title: PropTypes.string,
        UUID: PropTypes.string,
    }).isRequired,
};

ThankYouActionBar.defaultProps = {
    legacyurl: window.location.href,
    baseurl: window.location.href,
};

export default ThankYouActionBar;
